<main class="container-fluid p-4" #top>

<div class="d-flex align-items-center mb-3 gap-2">
	<fdx-page-title [classes]="{'mb-0': true}">Add export</fdx-page-title>
	<div class="ms-auto d-flex align-items-center gap-2">
        <button type="button" class="btn btn-discovery" (click)="switchToNewAddExport()">
            Try new exports
            <fa-icon [icon]="faArrowRight" class="fa-icon-right"/>
        </button>
		<button type="button" (click)="showHelp()" class="btn unstyled-button">
			<fa-icon [icon]="iconHelp" class="no-margin"></fa-icon>
		</button>
	</div>
</div>
<div class="card">
    <div class="card-body">
        <fdx-export-config-form-new
            [addExportError]="newExport.error"
            [exportItem]="newExport"
            [dbFields]="dbFields"
            [dbSortableFields]="dbFieldsSortable"
            [exportItems]="exports"
            [triggers]="triggers"
            (addExport)="addExport()"
            (exportChange)="mergeWithExport($event, false)"
            (exportFieldsChange)="mergeExportFields($event, false)"
            (webhookTypeChange)="changeWebhookType(newExport, { webhookType: $event })">
        </fdx-export-config-form-new>
    </div>
</div>

<div class="position-relative d-flex align-items-end justify-content-center mb-2 mt-4" #existingExportTitle>
    <h2 class="mb-0">Existing exports</h2>
    <div class="position-absolute end-0 d-flex align-items-end gap-2">
        <button type="button" class="btn btn-discovery" (click)="switchToNewExportDetails()">
            Try new exports
            <fa-icon [icon]="faArrowRight" class="fa-icon-right"/>
        </button>
        @if (exports.length > 0) {
            <button type="button" name="download-export-summary" class="btn btn-outline-ghost" (click)="downloadExportsSummary()">Download report - all exports</button>
        }
    </div>
</div>

<!-- Existing Export -->
<div class="card">
    <div class="card-body" *ngIf="currentExport && currentExport.hasOwnProperty('id'); else exportsLoading">

        <div class="border-bottom">

            <div class="row" >

                <!-- Choose export -->
                <div class="offset-3 col-6">
                    <div
                        [formGroup]="exportSelectForm">
                        <fdx-form-field
                            formControlName="existingExport"
                            [classes]="{'row': true}" >
                            <fdx-label class="col-3" [classes]="{'keep-padding': true}">Choose export:</fdx-label>
                            <fdx-input-wrapper
                                class="col">
                                <fdx-export-select
                                    controlName="existingExport"
                                    [formGroup]="exportSelectForm"
                                    [exports]="exports"
                                    [triggers]="triggers"
                                    [isEBSDatabase]="isEBSDatabase"
                                    [isEDSv2Database]="isEDSv2Database" >
                                </fdx-export-select>
                            </fdx-input-wrapper>
                        </fdx-form-field>
                    </div>

                    <div class="row mt-2">
                        <div class="offset-3 col text-secondary" *ngIf="showExportTriggersMessage()" >
                            This export is being used in export triggers.
                        </div>
                    </div>

                </div>

                <!-- Button Group -->
                <div class="col-3" >

                    <div class="row">
                        <div class="col d-flex justify-content-end" >
                            <span class="last-run-label me-3" *ngIf="currentExport.last_run_duration !== '0'">Last run time: {{ currentExport.last_run_duration | formatSeconds }}</span>

                            <!-- Reset Export -->
                            <button
                                type="button"
                                name="reset-export"
                                class="btn btn-outline-secondary me-2"
                                ngbTooltip="Reset export"
                                aria-label="Reset export"
                                triggers="mouseenter:mouseleave"
                                (click)="resetExport(currentExport)"
                                *ngIf="showResetExportButton"
                                [disabled]="currentExport.disable_reset_button">
                                <fa-icon [icon]="iconRedo" class="no-margin"></fa-icon>
                            </button>

                            <!-- Local Export -->
                            <button
                                type="button"
                                name="local-export"
                                class="btn btn-outline-secondary me-2"
                                ngbTooltip="Local export"
                                aria-label="Local export"
                                triggers="mouseenter:mouseleave"
                                (click)="runParallelExport(currentExport, 'false' , false)"
                                [disabled]="currentExport.export_running">
                                <fa-icon [icon]="iconDownload" class="no-margin"></fa-icon>
                            </button>

                            <!-- Simulated Local Export -->
                            <button
                                type="button"
                                name="time-simulated-local-export"
                                class="btn btn-outline-secondary me-2"
                                ngbTooltip="Time-simulated local export"
                                aria-label="Time-simulated local export"
                                triggers="mouseenter:mouseleave"
                                (click)="runParallelExportSimulated(currentExport, 'false' , false)"
                                [disabled]="currentExport.export_running">
                                <img src="/dist/app/assets/icons/download_clock.svg" alt="Time-simulated local export icon">
                            </button>

                            <!-- Webhook Export For Postman -->
                            <button
                                type="button"
                                name="download-webhook"
                                class="btn btn-outline-secondary me-2"
                                ngbTooltip="Download webhook for Postman"
                                aria-label="Download webhook for Postman"
                                triggers="mouseenter:mouseleave"
                                *ngIf="showDownloadWebhookForPostmanButton"
                                (click)="downloadWebhookForPostman(currentExport)"
                                [disabled]="currentExport.export_running">
                                <fa-icon [icon]="iconPostman" class="no-margin"></fa-icon>
                            </button>

                            <!-- Copy Export -->
                            <button
                                type="button"
                                name="copy-export"
                                class="btn btn-outline-secondary me-2"
                                [ngbTooltip]="disableFtpCopy ? 'Copy disabled for FTP exports.' : 'Copy'"
                                aria-label="Copy export"
                                triggers="mouseenter:mouseleave"
                                [disabled]="disableFtpCopy"
                                (click)="copyExportFields(currentExport)">
                                <fa-icon [icon]="iconCopy" class="no-margin"></fa-icon>
                            </button>

                            <!-- Delete Export -->
                            <button
                                type="button"
                                name="delete-export"
                                class="btn btn-outline-danger me-2"
                                ngbTooltip="Delete export"
                                aria-label="Delete export"
                                triggers="mouseenter:mouseleave"
                                (click)="deleteModal(currentExport)">
                                <fa-icon [icon]="iconTrash" class="no-margin"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="row mt-2 mb-1">
                        <div class="col d-flex justify-content-end align-items-center gap-1">
                            <small class="fw-bold">Last run:</small>
                            @if (showLastRunTimestamp) {
                                <button
                                    type="button"
                                    class="btn btn-sm btn-ghost px-1"
                                    #lrp="ngbPopover"
                                    [ngbPopover]="lastRunDateTimePopoverTemplate"
                                    [popoverTitle]="lastRunDateTimeTitleTemplate"
                                    placement="bottom auto"
                                    triggers="manual"
                                    (click)="lrp.open()">
                                    <fdx-date-time-localized
                                        [dateTime]="currentExport.timestamp">
                                        <fa-icon
                                            class="fa-icon-right"
                                            suffix
                                            [icon]="clockIcon"/>
                                    </fdx-date-time-localized>
                                </button>
                            } @else {
                                <small class="text-secondary">Never</small>
                            }
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="row">
            <!-- Submit -->
            <div class="form-group text-center mt-3">
                <!-- Parallel Exports -->
                <span>
                    <!-- Parallel Push Export -->
                    <div class="btn-group">
                        <button
                            type="button"
                            name="push-export"
                            (click)="confirmPushExportModal()"
                            [disabled]="currentExport.export_running"
                            class="btn btn-primary">Push export</button>
                        <button
                            type="button"
                            name="push-export-with-notification"
                            class="btn btn-primary"
                            (click)="confirmNotificationExportModal()"
                            *ngIf="isAnalyst"
                            [disabled]="currentExport.export_running"
                            ngbTooltip="Push export with notification"
                            aria-label="Push export with notification"
                            triggers="mouseenter:mouseleave">
                            <fa-icon [icon]="iconBell" class="no-margin"></fa-icon>
                        </button>
                    </div>

                    <!-- Post Download Button -->
                    @if (currentExport.last_download_link) {
                        <a class="btn btn-primary ms-1"
                            target="_blank"
                            [href]="currentExport.last_download_link"
                            rel="noopener" referrerpolicy="no-referrer">
                            Download last run
                        </a>
                    }
                </span>
            </div>

            <!-- Export is running -->
            <div *ngIf="currentExport.export_running" class="form-group text-center">
                <img src="/app/images/feeding_in_progress.gif"
                alt="Feed processing indicator">
                    We are attempting to process your data.  Some exports may take longer than others.  You can leave this page anytime.

            </div>

            <!-- Push Error -->
            <fdx-alert *ngIf="currentExport.run_error" theme="danger" [body]="currentExport.run_error"></fdx-alert>

            <!-- Export Information -->
            <div
                class="p-2"
                [class.modified]="currentExport.modified">
                <fdx-export-config-form-existing
                    [editExportError]="currentExport.error"
                    [exportItem]="currentExport"
                    [dbFields]="dbFields"
                    [dbSortableFields]="dbFieldsSortable"
                    [exportSaved]="currentExport.added_message"
                    [parentExport]="getParentExport(currentExport)"
                    (editExport)="editExport(currentExport)"
                    (exportChange)="mergeWithExport($event, true)"
                    (exportFieldsChange)="mergeExportFields($event, true)"
                    (webhookTypeChange)="changeWebhookType(currentExport, { webhookType: $event })"
                    (scheduleUpdated)="scheduleUpdateOnExportList($event)">
                </fdx-export-config-form-existing>
            </div>
            <div *ngIf="currentExport.saving_message" class="text-center">Saving export</div>
            <div *ngIf="currentExport.added_message" class="animate-show text-center">Export saved!</div>
        </div>
    </div>

    <ng-template #exportsLoading>
        <div class="card-body" *ngIf="this.exports.length !== 0">
            <fdx-spinner></fdx-spinner>
        </div>
    </ng-template>
</div>

</main>

<ng-template #lastRunDateTimeTitleTemplate>
    <fdx-popover-header titleText="Compare time zones">
    </fdx-popover-header>
</ng-template>

<ng-template #lastRunDateTimePopoverTemplate >
    <fdx-date-time-localized
        class="text-dark"
        [dateTime]="currentExport.timestamp" >
    </fdx-date-time-localized>
    <fdx-date-time-localized
        [dateTime]="currentExport.timestamp"
        [displayLocalTimezone]="true" >
    </fdx-date-time-localized>
</ng-template>
